import { Grid } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';
import * as colors from 'commons/styles/colors';

class InboundSummaryPageStyleClass extends CommonComponentStyle {
  TaskInfoWrapper = styled(Grid)`
    padding: 8px 0 16px 0;
  `;

  TaskNumberText = styled(Grid)`
    font-size: 16px;
    font-weight: 700;
  `;

  InvoiceInfoText = styled(Grid)`
    color: ${this.colors.PRIMARY_GRAY};
    font-weight: 700;
    font-size: 12px;
  `;

  HeaderWrapper = styled.div`
    padding: 8px 0;
    text-align: center;
  `;

  Header = styled.p<{ color?: string }>`
    font-size: 18px;
    font-weight: 700;
    display: inline-flex;
    margin-bottom: 0;
    color: ${(props): string => props.color || colors.PRIMARY_GREEN};
  `;

  ItemContentWrapper = styled(Grid)`
    &.table-content {
      padding: 8px 16px;
      font-size: 14px;
    }
  `;

  SubHeaderText = styled.p`
    margin: 8px 0;
    font-weight: 700;
    font-size: 14px;
    color: ${this.colors.PRIMARY_GRAY};
  `;
}

export default new InboundSummaryPageStyleClass();
